<template>
    <div class="min-h-screen bg-white">
        <HeaderComponent />
        <DemoComponent />
    </div>
</template>

<script>
import DemoComponent from './components/DemoComponent.vue'
import HeaderComponent from './components/Header.vue'

export default {
    name: 'App',
    components: {
        DemoComponent,
        HeaderComponent
    }
}
</script>

<style>
@import './styles.css';
</style>